module.exports = __webpack_public_path__ + "img/icon-guess@2x.db5dd5b1.png";